import * as Sentry from "@sentry/react";
import type { QueryClient } from "@tanstack/react-query";
import { QueryClientProvider } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import { lazy } from "react";

import RemovedFromCampaignNoticeWatcher from "@/components/campaigns/RemovedFromCampaignNoticeWatcher";
import FeedbackModalRoot from "@/components/feedback/FeedbackModalRoot";
import { ToastProvider } from "@/components/ui/ToastProvider";

const TanStackRouterDevtools =
  import.meta.env.DEV
    ? lazy(() =>
        import("@tanstack/react-router-devtools").then((mod) => ({
          default: mod.TanStackRouterDevtools,
        })),
      )
    : () => null;

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent() {
  const { queryClient } = Route.useRouteContext();

  return (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <QueryClientProvider client={queryClient}>
        <ToastProvider>
          <Outlet />
          <RemovedFromCampaignNoticeWatcher />
          <FeedbackModalRoot />
        </ToastProvider>
      </QueryClientProvider>
      {/* <Suspense>
        <TanStackRouterDevtools position="bottom-right" />
      </Suspense> */}
    </Sentry.ErrorBoundary>
  );
}
